import React, { Component } from 'react';
import { Layout } from 'element-react'
import i18n from '../../../plugins/i18n/i18n'
import { NavLink } from 'react-router-dom'
import { actions } from '../../../store/modules';
import { connect } from 'react-redux';
import { Form, Button, Input } from 'antd'
import queryString from "query-string";


class Activation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSend: false,
      loading: false,
      loginSuccess: null,
      errorMessage: null,
      form: {
        token: null,
        email: null
      }

    }
  }

  componentWillMount() {

    let params = queryString.parse(window.location.search);
    if (params && !params.token) {
      this.props.history.push(
        `/auth/sign-in`
      );
    }
    if (params && !params.email) {
      this.props.history.push(
        `/auth/sign-in`
      );
    }

    let { form } = this.state;
    form.token = decodeURIComponent(params.token);
    form.email = params.email;
    this.setState({ form })

  }

  fetch = (values) => {
    this.setState({
      loading: true
    })

    let { form } = this.state;

    var param = {
      email: form.email,
      password: values.password,
      token: form.token
    }

    this.props.dispatch(actions.auth.confirmEmail(param))
      .then(() => {
        this.fetchLogin(values.password)
      })
      .catch(error => {

        let responseErrorMessage = (error && error.errors && error.errors[0].error && error.errors[0].error) || (error && error.description && error.description) || (i18n.t('unknownErrorOccurred', { lng: this.props.currentLanguage }));

        this.setState(
          {
            loading: false,
            loginSuccess: false,
            errorMessage: responseErrorMessage

          },
          () => {
            setTimeout(() => {
              this.setState({ loginSuccess: null });
            }, 3500);
          })
      })
  }

  fetchLogin = (password) => {

    this.setState({ loading: true })
    let { form } = this.state;

    let _this = this;

    var param = {
      username: form.email,
      password: password
    }

    this.props.dispatch(actions.auth.login(param))
      .then(() =>{
        this.props.history.push(
          `/app/home`
        );
      })
  
      .catch(error => {

        let responseErrorMessage = JSON.parse(JSON.stringify(error)).response.data.error_description;
        this.setState(
          {
            loading: false,
            loginSuccess: false,
            errorMessage: responseErrorMessage
          },
          () => {
            setTimeout(() => {
              _this.setState({ loginSuccess: null });
            }, 3500);
          })
      })
  }


  render() {

    let { loading, loginSuccess, errorMessage } = this.state;

    return (
      !this.state.isSend ?
        <div className="form-content">
          <h1 className="heading">
            {i18n.t('activation', { lng: this.props.currentLanguage })}
          </h1>
          <Form layout="vertical"
            onFinish={this.fetch}
          >

            <Form.Item
              label={`${i18n.t("password", {
                lng: this.props.currentLanguage,
              })}`}
              name="password"
              rules={[
                {
                  required: true,
                  message: `${i18n.t("fieldIsRequired", {
                    lng: this.props.currentLanguage,
                  })}`,
                }
              ]}
            >
              <Input.Password
                placeholder={i18n.t("typeYourPassword", {
                  lng: this.props.currentLanguage,
                })}
              />
            </Form.Item>


            <Form.Item
              label={`${i18n.t("confirmPassword", {
                lng: this.props.currentLanguage,
              })}`}
              name="confirmPassword"
              style={{ marginTop: 26 }}
              rules={[
                {
                  required: true,
                  message: `${i18n.t("fieldIsRequired", {
                    lng: this.props.currentLanguage,
                  })}`,
                }
              ]}
            >
              <Input.Password
                placeholder={i18n.t("reTypeYourPassword", {
                  lng: this.props.currentLanguage,
                })}
              />
            </Form.Item>

            <div
              className="error"
              style={
                loginSuccess === false
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              {errorMessage}
            </div>
            <Form.Item>
              <Button
                className="width-100 mt-20"
                htmlType="submit"
                type="primary"
                loading={loading}
              >
                {i18n.t('signIn', { lng: this.props.currentLanguage })}
              </Button>
            </Form.Item>
          </Form>

          {/* <Layout.Row className="go-to-back">
            <NavLink to="/auth/sign-in">
              <p>
                {i18n.t('goToBack', { lng: this.props.currentLanguage })}
              </p>
            </NavLink>
          </Layout.Row> */}
        </div>
        :
        <div className="form-content">
          <h1 className="heading">
            {i18n.t('forgotPassword', { lng: this.props.currentLanguage })}
          </h1>

          <Layout.Row>
            <Layout.Col xs="24" sm="24" md="13" lg="13">
              <p className="p-desc">{i18n.t('helpIsOnTheWayLabel', { lng: this.props.currentLanguage })}</p>
            </Layout.Col>
          </Layout.Row>

          <Layout.Row className="go-to-back">
            <NavLink to="/auth/sign-in">
              <p>
                {i18n.t('goToBack', { lng: this.props.currentLanguage })}
              </p>
            </NavLink>
          </Layout.Row>
        </div>
    )
  }
}


const mapStateToProps = ({ auth }) => ({
  ...auth
});
export default connect(mapStateToProps)(Activation);






// WEBPACK FOOTER //
// ./src/components/Auth/Views/Activation.js